// extracted by mini-css-extract-plugin
export var barContainer = "_x-0";
export var extraThin = "_x-3";
export var fillBar = "_x-6";
export var fillContainer = "_x-4";
export var overflow = "_x-8";
export var overflowContainer = "_x-5";
export var regular = "_x-7";
export var thick = "_x-1";
export var thin = "_x-2";